

interface HeadingProps {
  title: string;
  className?: string;
}

function Heading({ title, className }: HeadingProps) {
  return (
    <div>
      <h1 className={`text-2xl font-aeonikBold capitalize text-blackCol font-bold ${className}`}>
        {title}
      </h1>
    </div>
  );
};

export default Heading;
